var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "Qr-Share" },
    [
      _c(
        "el-dialog",
        {
          staticClass: "productTypeDialog",
          attrs: {
            "custom-class": "planWordDialog",
            "append-to-body": true,
            title: "",
            visible: _vm.qrShow,
            width: "25%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.qrShow = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "Dialog-top",
              staticStyle: { "padding-top": "15px" },
            },
            [
              _c(
                "p",
                {
                  staticStyle: { "margin-bottom": "5px", "font-weight": "700" },
                },
                [
                  _vm._v(
                    "温馨提示：复制下方二维码,分享到手机端即可让用户浏览行程!"
                  ),
                ]
              ),
              _c("Qr", {
                staticStyle: { "text-align": "center" },
                attrs: {
                  bgSrc: _vm.bgSrc,
                  logoSrc: _vm.logoSrc,
                  text: _vm.text,
                },
              }),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }